import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';
import { AnlieferkennzeichenService } from '../../api';

export const getAnlieferkennzeichen =
  (mandantId: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new AnlieferkennzeichenService()
      .getAnlieferkennzeichen(mandantId)
      .then(result => {
        dispatch({
          type: ActionTypes.GET_ANLIEFERKENNZEICHEN,
          payload: result.data,
        });
      });
  };
